import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import Panel from 'components/Panel/Panel';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import { TASK_HEAD_COMPETITOR_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT, DELETE_MODAL_TITLES } from 'constants/interfaces';
import DeleteModal from 'pages/CompanyAdminPages/ValueChainMap/components/DeleteModal/DeleteModal';

import CreateCompetitor from './components/CreateCompetitor/CreateCompetitor';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityConfigCompetitor from './interfaces/IMaterialityConfigCompetitor';

import styles from './scss/MaterialityConfigCompetitor.module.scss';

function MaterialityConfigCompetitorView({
  isEmptyList, loading, onOpenModal, goBack, saveCompetitor, count, max, openModal,
  items, onDeleteItem, isDeleteModalOpen, onCancel, onDeleteConfirm, recordId, setOpenModal, vcmId,
  isViewOnly,
}: IMaterialityConfigCompetitor) {
  const { t } = useTranslation();

  return (
    <Panel className={styles.root}>
      <Button
        title={t('materialityAssessment.back')}
        onClick={goBack}
        variant={BUTTON_VARIANT.ghost}
        startIcon={<ArrowLeftIcon />}
      />
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleTableWrapper
            title={t('materialityAssessment.competitorAnalysis')}
            hint={t('materialityAssessment.competitorAnalysisHint')}
            buttonTitle={t('materialityAssessment.addCompetitor')}
            onButtonClick={onOpenModal}
            buttonClassName={styles.button}
            titleCounter={t('materialityAssessment.companies')}
            tooltipTitle={t('materialityAssessment.tooltipCompany')}
            disableButton={Number(max) === Number(count)}
            max={max}
            count={count}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyCompetitorDescription')}
                buttonTitle={t('materialityAssessment.addCompetitor')}
                buttonOnClick={onOpenModal}
                disabledButton={false}
                hideButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {items && items.length > 0 ? (
                  <ItemsTable
                    items={items}
                    headCells={TASK_HEAD_COMPETITOR_CELLS}
                    onDeleteItem={onDeleteItem}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                ) : null}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.save')}
            onClick={saveCompetitor}
            className={styles.button}
          />
        </div>
        <CreateCompetitor
          open={openModal}
          onClose={onOpenModal}
          title={t('materialityAssessment.addCompetitor')}
          recordId={recordId}
          setOpenModal={setOpenModal}
          vcmId={vcmId}
        />
        <DeleteModal
          open={isDeleteModalOpen}
          onReject={onCancel}
          isLoading={false}
          title={DELETE_MODAL_TITLES.DELETE_COMPETITOR}
          hint={DELETE_MODAL_TITLES.DELETE_COMPETITOR_HINT}
          onConfirm={onDeleteConfirm}
        />
      </div>
    </Panel>
  );
}

export default MaterialityConfigCompetitorView;
